import { MessageIcon, Phone3Icon, Settings3Icon, WorkBook3Icon } from "@/shared/icons";

export const phoneSystemAppsList = [
  {
    id: 1,
    icon: Phone3Icon,
    background: "linear-gradient(135deg, #53E374, #1FB337)",
  },
  {
    id: 2,
    icon: MessageIcon,
    background: "linear-gradient(135deg, #53E374, #1FB337)",
  },
  {
    id: 3,
    icon: Settings3Icon,
    background: "linear-gradient(135deg, #D3D3D3, #727272)",
  },
  {
    id: 4,
    icon: WorkBook3Icon,
    background: "linear-gradient(135deg, #E3B553, #B38C1F)",
  },
];
